/**
 * exportCSV.js — Export attendance records to CSV.
 * Includes Name and Student ID columns when available.
 */

export function exportToCSV(records) {
  if (!records || records.length === 0) {
    alert("No records to export.");
    return;
  }

  const headers = ["#", "Name", "Student / Emp. ID", "Card UID", "Timestamp", "Status"];

  const rows = records.map((r, i) => [
    i + 1,
    `"${r.name      || ""}"`,
    `"${r.studentId || ""}"`,
    `"${r.uid}"`,
    `"${r.timestamp}"`,
    `"${r.status}"`,
  ]);

  const csvContent = [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href  = url;
  link.setAttribute(
    "download",
    `attendance_${new Date().toISOString().slice(0, 10)}.csv`
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
